export function fioLitleTruncateFromObject(ObjectWithFIO) {
  try {
    let returnFio = "";
    let isEdited = false;

    if (ObjectWithFIO && typeof ObjectWithFIO === "object") {
      if (ObjectWithFIO.f && String(ObjectWithFIO.f).length) {
        let isAddedI = false;

        returnFio += ObjectWithFIO.f;
        isEdited = true;

        if (ObjectWithFIO.i && String(ObjectWithFIO.i).length) {
          returnFio += " " + String(ObjectWithFIO.i).substring(0, 1) + ".";
          isAddedI = true;
        }

        if (ObjectWithFIO.o && String(ObjectWithFIO.o).length) {
          if (!isAddedI) {
            returnFio += " ";
          }

          returnFio += String(ObjectWithFIO.o).substring(0, 1) + ".";
        }
      } else if (ObjectWithFIO.email && String(ObjectWithFIO.email).length) {
        returnFio = ObjectWithFIO.email;
        isEdited = true;
      }
    }

    if (isEdited) {
      return returnFio;
    } else {
      return "Ошибка в фамилии";
    }
  } catch (err) {
    console.log(err);
    return "Ошибка в фамилии";
  }
}

export function fioFromObject(ObjectWithFIO, emptyText) {
  let returnFio = "";

  if (
    ObjectWithFIO &&
    typeof ObjectWithFIO === "object" &&
    ObjectWithFIO.f &&
    ObjectWithFIO.i
  ) {
    try {
      returnFio = ObjectWithFIO.f + " " + ObjectWithFIO.i;

      if (ObjectWithFIO.o && ObjectWithFIO.o.length) {
        returnFio += " " + ObjectWithFIO.o;
      }

      return !returnFio.length && emptyText ? emptyText : returnFio;
    } catch (err) {
      console.log(err);
      return emptyText ? emptyText : "Ошибка в фамилии";
    }
  } else {
    return emptyText ? emptyText : returnFio;
  }
}

export function getFilialNameFromObject(filialIdFieldInObject) {
  return (
    (filialIdFieldInObject &&
      typeof filialIdFieldInObject === "object" &&
      filialIdFieldInObject.name) ||
    "Не указан"
  );
}

export function getQueryParams(query, isNotFirstParams) {
  let queryParams = "";

  if (query) {
    for (let key in query) {
      if (!queryParams.length) {
        queryParams += !isNotFirstParams ? "?" : "&";
      } else {
        queryParams += "&";
      }

      queryParams += `${key}=${query[key]}`;
    }
  }

  return queryParams;
}

export function getTypeHistory(typeHistory) {
  if (typeHistory) {
    switch (typeHistory) {
      case "api":
        return "Клиент";
      case "cms":
        return "Панель управления";
      default:
        return typeHistory;
    }
  } else {
    return "Не указано";
  }
}

export function getTypeHistoryStyle(typeHistory, setDefaultColor = "error") {
  if (typeHistory) {
    switch (typeHistory) {
      case "api":
        return "default";
      case "cms":
        return "success";
      default:
        return setDefaultColor;
    }
  } else {
    return setDefaultColor;
  }
}

export function getObjectIdFromField(field) {
  if (field) {
    if (typeof field === "object" && field._id) {
      return field._id;
    } else {
      return field;
    }
  } else {
    return null;
  }
}

/**
 * Знак минус для сумм.
 */
export const minusSum = "−";

/**
 * Знак плюс для сумм.
 */
export const plusSum = "+";

/**
 * Знак полупробел для сумм.
 */
export const spaceSum = " ";

/**
 * Суффикс денег
 */
export const suffixMoney = "тенге";

/**
 * Суффикс процентов
 */
export const suffixPercent = "%";

/**
 * Суффикс шт.
 */
export const suffixCount = "шт.";

/**
 * Форматирование суммы для отображения
 * @param {Number} number Число, которое необходимо отфарматировать
 * @param {String} [separator=" "] Разделитель. По умолчанию = полупробел.
 * @param {String} [prefix=""] Перед числом
 * @param {String} [suffix=""] После числа
 */
export function sumFormat(number, suffix = "", prefix = "", separator = ` `) {
  if (typeof number === "string") {
    return number;
  }

  const parts = number.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  let sum = parts.join(".");

  if (number < 0) {
    sum = `${minusSum}${sum.substring(1)}`;
  }

  if (suffix && suffix.length) {
    sum += `${separator}${suffix}`;
  }

  if (prefix && prefix.length) {
    sum = `${prefix}${sum}`;
  }

  return sum;
}

/**
 * Форматирование суммы для отображения денег с suffix-ом денег (тенге, рубли)
 * @param {Number} number Число, которое необходимо отфарматировать
 * @param {String} [suffix=""] После числа
 * @param {String} [prefix=""] Перед числом
 * @param {String} [separator=" "] Разделитель. По умолчанию = полупробел.
 */
export function sumFormatWithMoney(
  number,
  suffix = suffixMoney,
  prefix = "",
  separator = ` `
) {
  let sum = sumFormat(number, separator, prefix, suffix);

  sum += separator + suffix;

  return sum;
}
